export default __webpack_public_path__ + "static/media/active_sync_data_request_icon.df6276bf.svg";